import { useState } from "react";
import { useSelector } from "react-redux";
import { submitProduct } from "../services/productService";
import Swal from "sweetalert2";

const useProductForm = () => {
  const categoryData = useSelector((state) => state.products.categories);
  const unityData = useSelector((state) => state.products.unities);

  const [productName, setProductName] = useState("");
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedUnit, setSelectedUnit] = useState(null);
  const [selectedStore, setSelectedStore] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [fields, setFields] = useState([
    { type: "", prixAchat: "", prixVente: "", quantite: "", expirationDate: "", alerteQuantite: "" },
  ]);

  const handleFieldChange = (index, field, value) => {
    const newFields = [...fields];
    if (field === "expirationDate" && value) {
      // Formater la date avec moment pour qu'elle soit au format ISO
      newFields[index][field] = value.format("YYYY-MM-DD"); 
    } else {
      newFields[index][field] = value;
    }
  
    setFields(newFields);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    setError(null);

    if (!productName || !selectedCategory || !selectedUnit || !selectedStore || fields.length === 0) {
      setError("Veuillez remplir tous les champs.");
      setLoading(false);
      return;
    }

    const productData = {
      name: productName,
      category_id: selectedCategory.value,
      unit_id: selectedUnit.value,
      stock: selectedStore.value,
      variations: fields,
    };

    const response = await submitProduct(productData);
    setLoading(false);

    if (response.success) {
      Swal.fire({ text: "Produit ajouté avec succès !", icon: "success", confirmButtonText: "OK" });
    } else {
      setError(response.message);
    }
  };

  return {
    productName, setProductName,
    selectedCategory, setSelectedCategory,
    selectedUnit, setSelectedUnit,
    selectedStore, setSelectedStore,
    loading, error, fields,
    handleFieldChange, handleSubmit, categoryData , unityData
  };
};

export default useProductForm;
